import { axios } from "lib/axios";
import { useQuery } from "react-query";

export const getVisitors = () => {
  return axios.get("/visitors/total");
};

export const useVisitors = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["visitors"],
    queryFn: () => getVisitors(),
  });
};
